// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f6da84ac","60":"c575d9ba","293":"cdc44914","465":"cf2f87b3","598":"68d73382","601":"a36d1da7","626":"a1671c6a","730":"993e4129","815":"ba7d3108","826":"05c295d8","963":"a1313ebb"}[chunkId] + ".chunk.js";
};